import { gql } from "@apollo/client";

// Query to get the weather station status
export const GET_OFFLINE_DEVICES = (
    page?: number,
    pageSize?: number,
    orderBy: "asc" | "desc" = "desc",
    deviceType?: string,
    startDate?: string,
    endDate?: string
) => {
    // Paginación
    // Si no se pasa pageSize o page, no se aplica paginación
    const paginationArgs = pageSize && page
        ? `, limit: ${pageSize}, offset: ${(page ? (page - 1): 0) * pageSize}`
        : "";

    // Filtros para condición where
    const filters: string[] = [];

    // Tipo de dispositivo
    if (deviceType) {
        filters.push(`device_type: {_eq: ${deviceType}}`);
    }

    // Rango de fechas
    if (startDate || endDate) {
        const dateConditions = [];
        if (startDate) dateConditions.push(`_gte: "${startDate}"`);
        if (endDate) dateConditions.push(`_lte: "${endDate}"`);
        // Si hay un solo elemento en dateConditions, se agrega el operador de comparación
        filters.push(`created_at: { ${dateConditions.join(", ")} }`);
    }

    // Si hay filtros, se agrega la cláusula where
    const whereClause = filters.length > 0 ? `, where: { ${filters.join(", ")} }` : "";

    return gql`
        query MyQuery {
            its_offline_devices_aggregate(
                order_by: {created_at: ${orderBy}}
                ${whereClause}
            ){
                aggregate {
                    count
                }
            }
            its_offline_devices(
                order_by: {created_at: ${orderBy}}
                ${whereClause}
                ${paginationArgs}
            ) {
                id
                device_type
                description
                is_online
                created_at
            }
        }
    `;
}